import {
    Tabs,
    Tab,
    AllIc,
    ListTitle,
    ViewMore
} from '../meElements'
import {
    NewsSavedList,
    NewsSavedItem,
    NewsSavedTitle,
    NewsSavedCreatedAt,
    NewsSavedRemove,
    EmptyNews
} from './newsSavedElements'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
import {removeNews, getNewsSaved, loadMoreNewsSaved} from '../../../store/reducer/userSlice'
import Loading from '../../../components/loading'
import { useEffect, useState, useRef } from 'react'

const NewsSaved = () => {
    const { user, isLoading, newsSaved } = useSelector(state => state.user)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const _page = useRef(1)

    const handleRemoveNews = async id => {
        setLoading(true)
        await dispatch(removeNews(id))
        await dispatch(getNewsSaved({ _limit: _page.current * 10 }))
        setLoading(false)
    }

    useEffect(() => {
        (async () => {
            _page.current = 1
            setLoading(true)
            await dispatch(getNewsSaved({_page: _page.current}))
            setLoading(false)
        })()
    }, [dispatch])

    useEffect(() => {
        (async () => {
            _page.current = 1
            setLoading(true)
            await dispatch(getNewsSaved({_page: _page.current}))
            setLoading(false)
        })()
    }, [dispatch, _page])

    const handleViewMore = async () => {
        ;(async () => {
            setLoading(true)
            await dispatch(loadMoreNewsSaved({ _page: _page.current + 1 }))
            setLoading(false)
            _page.current += 1
        })()
    }

    return (
        <>
            {loading && <Loading />}
            <Tabs>
                <Tab className="active"><AllIc /> Tất cả</Tab>
            </Tabs>
            <ListTitle>Tin đã lưu</ListTitle>
            {newsSaved.length === 0 ? 
                <EmptyNews>Bạn chưa lưu bài viết nào.</EmptyNews>:
                <NewsSavedList>
                    {!isLoading && newsSaved?.map(news => (
                        <NewsSavedItem key={news._id}>
                            <NewsSavedTitle title={news.title} to={`/news/${news._id}`}>{news.title}</NewsSavedTitle>
                            <NewsSavedCreatedAt>{moment(news.createdAt).format('DD/MM/yyyy')}</NewsSavedCreatedAt>
                            <NewsSavedRemove onClick={() => handleRemoveNews(news._id)} />
                        </NewsSavedItem>
                    ))}
                </NewsSavedList>
            }
            {!loading && user.newsSaved.length > 10 && newsSaved.length < user.newsSaved.length && <ViewMore onClick={handleViewMore} >{loading ? 'Đang load...':'Xem thêm bình luận'}</ViewMore>}
        </>
    )
}

export default NewsSaved
